import { render, staticRenderFns } from "./DFieldCheckbox.vue?vue&type=template&id=8fb93752&"
import script from "./DFieldCheckbox.vue?vue&type=script&lang=js&"
export * from "./DFieldCheckbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports